import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ILiveStream } from '@obvious.tech/constellation'

export const LiveStream = defineEntity('LiveStream', {
  endpoint: 'videomanager/api/LiveStream',
  schema: SNoop<ILiveStream>(),
})
